// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2NZ7i","visuallyhidden":"_2NSBR","hide-text":"_3PgMu","center":"_33dhu","noprint":"_6Z_oE","leadText":"kr_NJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-lead-text/styles/LeadText_Factbox.scss
 ** module id = 948
 ** module chunks = 1
 **/